import { Suspense, lazy, useState } from "react";
import { Helmet } from "react-helmet";
import "./App.css";
import 'animate.css';

const HeroSection = lazy(() => import("./components/HeroSection"))
const AboutMe = lazy(() => import("./components/AboutMe"));
const Skills = lazy(() => import("./components/Skills"))
const Projects = lazy(() => import("./components/Projects"))
const Achievement = lazy(() => import("./components/Achievements"))
const ContactForm = lazy(() => import("./components/ContactForm"))
const Footer = lazy(() => import("./components/Footer"))

function App() {

  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "wireframe"
  );

  return (
    <div className="App">
      <Helmet>
        <title>Harsh Raghavani</title>
        <meta name="description" content="Harsh Raghavani Portfolio" />
        <meta name="keywords" content="Harsh Raghavani" />
      </Helmet>
      <Suspense
        fallback={
          <div className={`flex items-center justify-center h-screen ${theme === "night" ? "dark-background" : "light-background"}`}>
            <span className={`loading loading-dots loading-lg text-white ${theme === "night" ? "text-white" : "text-black"}`}></span>
          </div>
        }
      >
        <HeroSection theme={theme} setTheme={setTheme} />
        <AboutMe theme={theme} setTheme={setTheme} />
        <Skills theme={theme} setTheme={setTheme} />
        <Projects theme={theme} setTheme={setTheme} />
        <Achievement theme={theme} setTheme={setTheme} />
        <ContactForm theme={theme} setTheme={setTheme} />
        <Footer theme={theme} setTheme={setTheme} />
      </Suspense>
    </div>
  );
}

export default App;
